/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

/**
 *
 * InitiateRefundModalV2
 *
 */

import React, { memo, useEffect, useRef, useState, useContext } from 'react';
// import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';

import {
  Modal,
  ModalContent,
  ModalHeader,
  Button,
  Space,
  Text,
  Popup,
  Conditional,
  Cross,
  RadioButton,
} from '@cashfree-intl/coherent';
import upperCase from 'lodash/upperCase';

import { useInjectSaga } from 'utils/injectSaga';
import { useInjectReducer } from 'utils/injectReducer';
import { getCurrencySymbol, roundOffNumber, titleCase } from 'utils/common';
import { INSTANT, STANDARD } from 'utils/constants';

import Loader from 'components/Loader';
import FormikComponent from 'components/Formik';
import CustomIcon from 'components/CustomIcons';

import useClickOutside from 'utils/hooks';
import {
  createRefundAction,
  enableLoaderAction,
  disableLoaderAction,
  getVendorDataAction,
  getMaximumRefundAction,
  resetModalDataAction,
  getWalletStatusAction,
  getInstantRefundEligibilityAction,
  getRechargeAccountDetailsAction,
  updateDefaultRefundSpeedAction,
  getObppStatusAction,
} from './actions';
import saga from './saga';
import reducer from './reducer';
import makeSelectInitiateRefundModalV2 from './selectors';

import highlighter from '../../images/highlighter.svg';

import { MerchantContext } from '../../contexts/MerchantContext';

import validationSchema, { validate } from './validation';
import {
  InstantSpeedSection,
  StandardSpeedSection,
  StyledDivider,
  StyledFieldWrapper,
  TextNote,
  StyledSmallInfo,
  StyledModalFooter,
} from './styled';
import {
  ELIGIBLE_REFUND_AMOUNT_BREAKDOWN,
  INITIATE_REFUND,
  INSTANT_REFUND_CHARGES_BREAKDOWN,
  INSUFFICIENT_BALANCE,
  RECHARGE_PENDING,
  STOPWATCH_ICON_URL,
  WALLET_STATUS_ACTIVE,
} from './constants';
import InsufficientAmountModal from './components/InsufficientAmountModal';
import RechargePendingModal from './components/RechargePendingModal';
import RefundInitiatedModal from './components/RefundInitiatedModal';
import AmountBreakdown from './components/AmountBreakdown';
import RefundAmountField from './components/RefundAmountField';
import {
  FormData,
  // FormikErrors,
  // FormikValues,
  IREligibilityType,
  ModalContentType,
} from './types';
import InstantRefundsActivationSuccessfulModal from 'containers/Payments/components/InstantRefundsActivationSuccessfulModal';

export function InitiateRefundModalV2(props) {
  useInjectReducer({ key: 'initiateRefundModalV2', reducer });
  useInjectSaga({ key: 'initiateRefundModalV2', saga, mode: '' });

  const {
    open,
    closeModal,
    createRefund,
    data = {},
    enableLoader,
    disableLoader,
    initiateRefundModalV2,
    getVendorData,
    getMaximumRefund,
    resetModalData,
    getWalletStatus,
    getRechargeAccountDetails,
    getInstantRefundEligibility,
    updateDefaultRefundSpeed,
    onRefundSuccess,
    getObppStatus,
  } = props;

  // data.transactionAmount

  const {
    isLoading,
    vendorsStatus = [],
    maximumRefund: maximumRefundAmount,
    disputedAmount,
  } = initiateRefundModalV2;

  const { setMerchantContextData, ...merchantContextData } = useContext(
    MerchantContext,
  );

  const { instantRefundsFreeTrialEligibility = {} } = merchantContextData;

  const [isSuccessful, setSuccessful] = useState(false);
  const [formData, resetFormData] = useState<FormData>({});
  const [merchantAmount, resetMerchantAmount] = useState(0);
  const [splitVendorArray, resetSplitVendorArray] = useState([]);
  const [displayNote, setDisplayNote] = useState(false);
  const [totalCharges, setTotalCharges] = useState(0);
  const [serviceFee, setServiceFee] = useState();
  const [tax, setTax] = useState();
  const [irEligibility, setIrEligiblity] = useState<IREligibilityType>({});
  // const [defaultRefundSpeed, setDefaultSpeed] = useState('');
  // const [instantRefund, setInstantRefund] = useState(defaultIr);
  // const [refundAmount, setRefundAmount] = useState(); // check if this needed anymore
  const [loading, setIsLoading] = useState(false);
  const [disabledIrError, setDisabledIrError] = useState<string>('');
  const [modalContent, setModalContent] = useState<ModalContentType>({ name: '' });
  const [walletStatus, setWalletStatus] = useState({ balance: 0, status: '' });

  // const [errArray, resetErrArray] = useState([]);
  // const [updatedArray, resetUpdatedArray] = useState([]);
  const isSplit = data.vendorSplit && data.vendorSplit.length > 0;

  const closeModalWithDataReset = () => {
    resetModalData();
    closeModal();
  };

  useEffect(() => {
    if (vendorsStatus && vendorsStatus.length && isSplit) {
      const splitArray = [];
      data.vendorSplit.forEach((vendor, index) => {
        splitArray.push({
          name: vendor.vendorId,
          amount: vendorsStatus[index] === 'DELETED' ? 0.0 : vendor.amount,
        });
      });
      resetSplitVendorArray(splitArray);
    }
  }, [vendorsStatus]);

  const onActivateInstantly = () => {
    enableLoader();
    // if default refund speed config is not present then post else patch
    // close the modal i.e. reset the modal name
    // debugger;
    updateDefaultRefundSpeed({
      cb: () => {
        setModalContent({
          name: 'INSTANT_REFUND_ACTIVATION_SUCCESS',
        });
        setTimeout(() => {
          closeModalWithDataUpdate(true);
        }, 4000);
      },
    });
  };

  const handleIrEligibilityResponse = response => {
    const {
      eligibilityStatus,
      defaultSpeed,
      serviceCharge,
      serviceTax,
      freeCreditsLeft,
    } = response;
    // calculate the charges and taxes
    const updatedTotalCharges = serviceCharge + serviceTax;
    setTotalCharges(roundOffNumber(updatedTotalCharges));
    setServiceFee(serviceCharge);
    setTax(serviceTax);
    // setDefaultSpeed(defaultSpeed);
    // set the IR eligibility and the default speed
    setIrEligiblity({
      eligibilityStatus,
      defaultSpeed:
        !eligibilityStatus && defaultSpeed === upperCase(INSTANT)
          ? upperCase(STANDARD)
          : defaultSpeed || upperCase(STANDARD),
      freeCreditsLeft: freeCreditsLeft || 0,
    });

    setModalContent({ name: INITIATE_REFUND });

    disableLoader();
    // commenting this as we don't want to show the error in case IR is not eligible and there is some error
    // Check this - we want to show this at the bottom of the modal
    if (!eligibilityStatus && response.errorResponse) {
      setDisabledIrError(response.errorResponse);
    }
    setIsLoading(false);
  };

  const fetchRechargeAccountDetails = () => {
    getRechargeAccountDetails({
      cb: response => {
        // console.log('recharge account detauls - ', response);
        setModalContent({ name: INSUFFICIENT_BALANCE, data: response });
      },
      errorCb: closeModalWithDataReset,
    });
  };

  const proceedWithRefundEligibility = (response) => {
    setIsLoading(true);
    // Get Instant Refund Eligibility
    getInstantRefundEligibility({
      transactionId: data.refId,
      refundAmount: response.refundableAmount,
      cb: handleIrEligibilityResponse,
      errorCb: () => {
        setIsLoading(false),
          handleIrEligibilityResponse({
            eligibilityStatus: false,
            defaultSpeed: upperCase(STANDARD),
            serviceCharge: 0,
            serviceTax: 0,
            freeCreditsLeft: 0,
          });
      },
    });

    // Get Vendor Split data
    if (isSplit) {
      const vendorSplitData = data.vendorSplit;
      if (isSplit && vendorSplitData.length) {
        getVendorData({
          vendorSplitData,
          errorCb: closeModalWithDataReset,
        });
      }
    }
  }

  const getModalData = walletData => {
    getMaximumRefund({
      txId: data.refId,
      errorCb: closeModalWithDataReset,
      cb: response => {
        // const { status, balance } = walletData;
        proceedWithRefundEligibility(response);
        // getObppStatus({
        //   cb: obppRes => {
        //     // OBPP enabled if configKey is OBPP_MERCHANT and both status and configValue are ACTIVE
        //     const isObppEnabled = Array.isArray(obppRes)
        //       ? obppRes.some(
        //           item =>
        //             item.status === 'ACTIVE' &&
        //             item.configKey === 'OBPP_MERCHANT' &&
        //             item.configValue === 'ACTIVE'
        //         )
        //       : obppRes &&
        //         obppRes.status === 'ACTIVE' &&
        //         obppRes.configKey === 'OBPP_MERCHANT' &&
        //         obppRes.configValue === 'ACTIVE';
        //     if (isObppEnabled) {
        //       proceedWithRefundEligibility(response);
        //       return;
        //     }
        //     // Only show insufficient balance if NOT OBPP enabled
        //     if (
        //       status === WALLET_STATUS_ACTIVE &&
        //       response.refundableAmount > balance
        //     ) {
        //       fetchRechargeAccountDetails();
        //     } else {
        //       proceedWithRefundEligibility(response);
        //     }
        //   },
        //   errorCb: closeModalWithDataReset,
        // });
      },
    });
  };

  useEffect(() => {
    // enable full page loader
    enableLoader();
    // setIsLoading(true);
    getWalletStatus({
      successCb: response => {
        setWalletStatus(response || 0);
        getModalData(response);
      },
    });
  }, []);

  const modalRef = useRef(null);

  const { refId, orderCurrency = 'INR' } = data;

  const currencySymbol = getCurrencySymbol(orderCurrency);

  const currency =
    !currencySymbol || currencySymbol === '' ? orderCurrency : currencySymbol;

  // const [showFooter, resetFooterDisplay] = useState(true);



  const handleFormSubmit = (values, actions) => {
    const requestedSpeed = values.refundSpeed;
    let splitDetails = {};
    if (isSplit && values.splitRefund) {
      splitDetails = values.splitVendorArray.map(vendor => ({
        merchantVendorId: vendor.name,
        amount: values.splitRefund ? Number(vendor.amount) : 0,
      }));
    }
    const payload = {
      refund_amount: +roundOffNumber(values.refundAmount),
      refund_note: values.note,
      reference_id: refId,
      is_split: isSplit && values.splitRefund,
      ...(isSplit && values.splitRefund
        ? { split_details: splitDetails } // eslint-disable-line
        : {}),
      requested_speed: upperCase(requestedSpeed),
    };

    let splitSum = 0;
    if (values.splitVendorArray.length) {
      splitSum = values.splitVendorArray.reduce(
        (val1, val2) =>
          Number(val1) + (values.splitRefund ? Number(val2.amount) : 0),
        0,
      );
    }

    resetMerchantAmount(Number(values.refundAmount) - splitSum);
    const formDetails = {
      ...payload,
      splitDetails: payload.split_details,
    };
    resetFormData(formDetails);

    // close the modal here and show the full screen loader
    // setModalContent();
    // enable loader
    enableLoader();
    createRefund({
      data: payload,
      actions,
      cb: response => {
        setSuccessful(true);
        // console.log('response is - ', response);
        // set the success modal here
        setModalContent({
          name: 'REFUND_INITIATED',
          data: {
            ...response,
            refundAmount: payload.refund_amount,
            defaultSpeed: irEligibility?.defaultSpeed,
            payload,
          },
        });
        if (onRefundSuccess) onRefundSuccess();
        if (upperCase(payload.requested_speed) === upperCase(INSTANT))
          // updating the free credits left
          setMerchantContextData({
            ...merchantContextData,
            instantRefundsFreeTrialEligibility: {
              ...instantRefundsFreeTrialEligibility,
              freeCreditsLeft: response.freeCreditsLeft,
            },
          });
      },
    });
  };

  const closeModalWithDataUpdate = updateRefundSpeed => {
    setSuccessful(false);
    resetFormData({});
    resetModalData();
    closeModal({ shouldRefreshData: true, updateRefundSpeed });
  };

  const onConfirmRecharge = () => {
    setModalContent({
      name: RECHARGE_PENDING,
    });
    // auto close the recharge pending modal
    setTimeout(() => {
      setModalContent({
        name: '',
      });
      closeModalWithDataReset();
    }, 3000);
  };

  const onRefreshBalance = callbackFn => {
    getWalletStatus({
      callbackFn,
      successCb: response => {
        // also check the activation state
        setWalletStatus(response || 0);
      },
    });
  };

  useClickOutside(modalRef, closeModalWithDataReset);

  const renderSuccessContent = () => (
    <div className="success-modal-content">
      <div className="success-header">
        <div className="success-icon">
          <CustomIcon componentName="GREEN_TICK_BIG" />
        </div>
        <div>Refund Initiated Successfully</div>
        <div>
          {currency} {formData.refund_amount}
        </div>
      </div>
      {isSplit ? (
        <div>
          <div className="split-desc">
            <div>Merchant Split Amount</div>
            <div className="split-currency">
              {currency} {roundOffNumber(merchantAmount)}
            </div>
          </div>
          <div className="divider" />
          <div className="vendor-details-header"> Vendor-wise Split Amount</div>
          {formData.splitDetails.map(vendor => (
            <div className="split-desc mt-16">
              <div>{vendor.merchantVendorId}</div>
              <div className="split-currency">
                {currency} {roundOffNumber(vendor.amount)}
              </div>
            </div>
          ))}
          <div />
        </div>
      ) : null}
      <div className="close-modal">
        <Button
          fluid
          primary
          onClick={closeModalWithDataUpdate}
          data-testId="close"
          data-event-name="Primary_Button_Close"
          data-ignore-inner-text="true"
        >
          Close
        </Button>
      </div>
    </div>
  );

  const handleRefundAmountChange = e => {
    e.persist();
    const refundAmountFieldVal = e.target.value;
    getInstantRefundEligibility({
      transactionId: data.refId,
      refundAmount: refundAmountFieldVal,
      cb: response => {
        const { serviceCharge, serviceTax } = response;
        const updatedTotalCharges = serviceCharge + serviceTax;
        // setRefundAmount(refundAmountFieldVal);
        setServiceFee(serviceCharge);
        setTax(serviceTax);
        setTotalCharges(roundOffNumber(updatedTotalCharges));

        // setTimeout(() => {
        //   const input = e.target;
        //   if (input) input.focus();
        // }, 0);
      },
    });
  };

  const renderModalContent = () => {
    const { eligibilityStatus, defaultSpeed, freeCreditsLeft } = irEligibility;
    if (
      (!isSplit ||
        (vendorsStatus.length &&
          vendorsStatus.length === splitVendorArray.length)) &&
      maximumRefundAmount !== undefined
    ) {
      if (isSuccessful) {
        return renderSuccessContent();
      }
      return (
        <>
          <Space alignItems="center" justifyContent="space-between">
            <Space alignItems="flex-start" gap={1}>
              <Text variant="h16" color="bodyLight">
                Eligible Refund Amount
              </Text>
              {/* Logic on backend -> refundableAmount = (txnAmt) - refundedAmt - disputedAmt
              // deriving the formula for Refunded Amount from this -> refundedAmt = txnAmt − refundableAmount − disputedAmt */}
              <Popup
                className="p-2"
                content={
                  <AmountBreakdown
                    data={{
                      ...data,
                      maximumRefundAmount,
                      disputedAmount,
                      refundedAmount:
                        Number(data.transactionAmount) -
                        Number(maximumRefundAmount) -
                        Number(disputedAmount),
                    }}
                    content={ELIGIBLE_REFUND_AMOUNT_BREAKDOWN}
                  />
                }
                hoverable
                trigger={
                  <span className="info pointer">
                    <CustomIcon componentName="INFO" width="16" height="16" />
                  </span>
                }
                position={'bottom center'}
              />
            </Space>
            <Text variant="h16" strong>
              {currency} {roundOffNumber(maximumRefundAmount)}
            </Text>
          </Space>
          <StyledDivider />
          <div>
            <FormikComponent
              initialValues={{
                refundAmount: roundOffNumber(maximumRefundAmount) || 0,
                note: '',
                splitRefund: isSplit,
                splitVendorArray,
                merchantUpdatedArray: [],
                refundSpeed:
                  eligibilityStatus &&
                    defaultSpeed !== upperCase(INSTANT) &&
                    freeCreditsLeft > 0
                    ? upperCase(INSTANT)
                    : irEligibility?.defaultSpeed,
                // useInstantRefund: false,
                // instantRefund: defaultIr,
              }}
              validate={validate(maximumRefundAmount)}
              validationSchema={validationSchema(isSplit)}
              validateOnMount
              onSubmit={handleFormSubmit}
              enableReinitialize
            >
              {formikProps => {
                const {
                  values,
                  handleFieldBlur,
                  handleFieldChange,
                  handleSubmit,
                  errors,
                  touched,
                  setFieldValue,
                  isValidating,
                  isSubmitting,
                } = formikProps;

                const showError = !!errors.refundAmount;
                let splitSum = 0;
                if (values.splitVendorArray.length) {
                  splitSum = values.splitVendorArray.reduce(
                    (val1, val2) =>
                      Number(val1) +
                      (values.splitRefund ? Number(val2.amount) : 0),
                    0,
                  );
                }
                let initialSum = 0;
                if (splitVendorArray.length) {
                  initialSum = splitVendorArray.reduce(
                    (val1, val2) =>
                      Number(val1) +
                      (values.splitRefund ? Number(val2.amount) : 0),
                    0,
                  );
                }
                const merchantAmount =
                  Number(values.refundAmount) - splitSum > 0
                    ? roundOffNumber(Number(values.refundAmount) - splitSum)
                    : '0.00';
                const initialMerchantAmount =
                  Number(maximumRefundAmount) - initialSum > 0
                    ? roundOffNumber(Number(maximumRefundAmount) - initialSum)
                    : '0.00';

                const splitErrorDisable =
                  splitSum > Number(values.refundAmount);

                const disableField = !isValidating && isSubmitting;

                {
                  /* add margin to the below div if radio buttons need to be rendered */
                }
                {
                  /* use the below div only to control the visibility if the fields if Standard is selected */
                }

                const isInstantSelected =
                  values.refundSpeed === upperCase(INSTANT);
                const isStandardSelected =
                  values.refundSpeed === upperCase(STANDARD);

                const standardRefundStyledFieldWrapper = (
                  <Conditional if={defaultSpeed === upperCase(STANDARD)}>
                    <StyledFieldWrapper
                      className={isStandardSelected ? 'selected' : ''}
                    >
                      <Space
                        alignItems="center"
                        justifyContent="space-between"
                        className={isStandardSelected ? 'mb-2' : ''}
                      >
                        {/* we can add a check to show either the text here a radio button here */}
                        <Conditional
                          if={
                            !eligibilityStatus &&
                            defaultSpeed === upperCase(STANDARD)
                          }
                        >
                          <Text className="h18" strong>
                            Standard Refund
                          </Text>
                        </Conditional>
                        <Conditional if={eligibilityStatus}>
                          <RadioButton
                            className="refund-speed-radio"
                            key="standardRefund"
                            label="Standard Refund"
                            onClick={() =>
                              setFieldValue('refundSpeed', 'STANDARD')
                            }
                            checked={isStandardSelected}
                            data-ignore-inner-text="true"
                            data-event-name="Form_InitiateRefundV2_Radio_RefundSpeed"
                            data-event-properties={JSON.stringify({
                              value: 'STANDARD',
                            })}
                            name="refundSpeed"
                            value="STANDARD"
                          />
                        </Conditional>
                        <StandardSpeedSection>
                          <Space alignItems="center" gap={0.25}>
                            <img src={STOPWATCH_ICON_URL} alt="stopwatch" />
                            <Text className="h10" strong color="warning">
                              Refund in 5-7 days
                            </Text>
                          </Space>
                        </StandardSpeedSection>
                      </Space>
                      {isStandardSelected && (
                        <div>
                          <div
                            className={
                              eligibilityStatus ? 'margin-left-30' : ''
                            }
                          >
                            <RefundAmountField
                              values={values}
                              currency={currency}
                              errors={errors}
                              handleFieldBlur={handleFieldBlur}
                              handleFieldChange={handleFieldChange}
                              handleRefundAmountChange={
                                handleRefundAmountChange
                              }
                              disableField={disableField}
                              displayNote={displayNote}
                              setDisplayNote={setDisplayNote}
                              maximumRefundAmount={maximumRefundAmount}
                              showError={showError}
                              isSplit={isSplit}
                              merchantAmount={merchantAmount}
                              formikProps={formikProps}
                              // eligibilityStatus={eligibilityStatus}
                              splitVendorArray={splitVendorArray}
                              initialMerchantAmount={initialMerchantAmount}
                              vendorsStatus={vendorsStatus}
                              touched={touched}
                              // inputRef={inputRef}
                              // Prem add a condition here that if refund wallet is not active then show another message
                              note={
                                isSplit ? null : (
                                  <Conditional
                                    if={
                                      walletStatus?.status ===
                                      WALLET_STATUS_ACTIVE
                                    }
                                  >
                                    <TextNote variant="b12" color="bodyLight">
                                      Refund amount to be deducted from your
                                      refund wallet
                                    </TextNote>
                                  </Conditional>
                                )
                              }
                            />
                          </div>
                        </div>
                      )}
                      {/* Experiment */}
                    </StyledFieldWrapper>
                  </Conditional>
                );

                const instantRefundStyledFieldWrapper = (
                  <Conditional
                    if={
                      eligibilityStatus || defaultSpeed === upperCase(INSTANT)
                    }
                  >
                    <StyledFieldWrapper
                      className={isInstantSelected ? 'mt-1 selected' : 'mt-1'}
                    >
                      <Space alignItems="center" justifyContent="space-between">
                        {/* we can add a check to show either the text here a radio button here */}
                        <Conditional if={defaultSpeed === upperCase(INSTANT)}>
                          <Text className="h18" strong>
                            Instant Refund
                          </Text>
                        </Conditional>
                        <Conditional
                          if={
                            eligibilityStatus &&
                            defaultSpeed !== upperCase(INSTANT)
                          }
                        >
                          <RadioButton
                            className="refund-speed-radio"
                            key="instantRefund"
                            label="Instant Refund"
                            name="refundSpeed"
                            value="INSTANT"
                            data-ignore-inner-text="true"
                            data-event-name="Form_InitiateRefundV2_Radio_RefundSpeed"
                            data-event-properties={JSON.stringify({
                              value: 'INSTANT',
                            })}
                            onClick={() =>
                              setFieldValue('refundSpeed', 'INSTANT')
                            }
                            checked={isInstantSelected}
                          />
                        </Conditional>
                        <InstantSpeedSection>
                          <Space alignItems="center" gap={0.25}>
                            <CustomIcon componentName="FLASH" fill="#00B7B1" />
                            <Text
                              className="h10"
                              strong
                              color="marketingPrimary"
                            >
                              Refund in seconds
                            </Text>
                          </Space>
                        </InstantSpeedSection>
                      </Space>
                      {/* UI for checked and unchecked status */}
                      {/* isStandardSelected and free trial is available */}
                      {isStandardSelected && eligibilityStatus && (
                        <div className="margin-left-30 instant-refunds">
                          <Text>
                            {/* Check this when to show one of these texts */}
                            {/* First text - */}
                            {/* Fast-track your business with lightning-fast refunds—opt-in for our trial now! */}
                            {/* Second text - */}
                            {/* Try for free to enhance your customer experience. */}
                            {freeCreditsLeft > 0
                              ? 'Boost customer satisfaction with swift refunds'
                              : 'Keep your customers worry-free by lightning fast refunds'}
                          </Text>
                          <Conditional if={freeCreditsLeft > 0}>
                            <Space alignItems="center" gap={1} className="mt-1">
                              {/* <CustomIcon componentName="HIGHLIGHTER" /> */}
                              <img src={highlighter} alt="Highlighter" />
                              <Text variant="b12">
                                {freeCreditsLeft} Free Trials
                              </Text>
                            </Space>
                          </Conditional>
                        </div>
                      )}
                      {isInstantSelected && (
                        <div>
                          <div
                            className={
                              eligibilityStatus &&
                                defaultSpeed !== upperCase(INSTANT)
                                ? 'margin-left-30 mt-2'
                                : 'mt-2'
                            }
                          >
                            <RefundAmountField
                              values={values}
                              currency={currency}
                              errors={errors}
                              handleFieldBlur={handleFieldBlur}
                              handleFieldChange={handleFieldChange}
                              handleRefundAmountChange={
                                handleRefundAmountChange
                              }
                              disableField={disableField}
                              displayNote={displayNote}
                              setDisplayNote={setDisplayNote}
                              maximumRefundAmount={maximumRefundAmount}
                              showError={showError}
                              touched={touched}
                              isSplit={isSplit}
                              // inputRef={inputRef}
                              merchantAmount={merchantAmount}
                              formikProps={formikProps}
                              vendorsStatus={vendorsStatus}
                              splitVendorArray={splitVendorArray}
                              // eligibilityStatus={eligibilityStatus && defaultSpeed !== upperCase(INSTANT)}
                              initialMerchantAmount={initialMerchantAmount}
                              note={
                                freeCreditsLeft > 0 ? (
                                  <TextNote variant="b12" color="bodyLight">
                                    {freeCreditsLeft} free trials left. Boost customer satisfaction with swift refunds.
                                  </TextNote>
                                ) : (
                                  <TextNote variant="b12" color="bodyLight">
                                    Instant Refund processing fee to be deducted
                                    from <br /> your{' '}
                                    {walletStatus?.status ===
                                      WALLET_STATUS_ACTIVE
                                      ? 'refund wallet'
                                      : 'account'}
                                    <span className="text-dark mx-1 w-600">
                                      {currency}
                                      {totalCharges}
                                    </span>
                                    <Popup
                                      className="p-2"
                                      hoverable
                                      content={
                                        <AmountBreakdown
                                          data={{
                                            refundAmount: values.refundAmount,
                                            serviceFee,
                                            tax,
                                            totalCharges,
                                            totalAmount: roundOffNumber(
                                              +values.refundAmount +
                                              +totalCharges,
                                            ),
                                          }}
                                          content={
                                            INSTANT_REFUND_CHARGES_BREAKDOWN
                                          }
                                        />
                                      }
                                      trigger={
                                        <StyledSmallInfo className="info pointer">
                                          <CustomIcon componentName="INFO" />
                                        </StyledSmallInfo>
                                      }
                                      position="bottom center"
                                    />
                                  </TextNote>
                                )
                              }
                            />
                          </div>
                        </div>
                      )}
                    </StyledFieldWrapper>
                  </Conditional>
                );

                return (
                  <form autoComplete="off" onSubmit={handleSubmit}>
                    {freeCreditsLeft > 0 ? (
                      <>
                        {instantRefundStyledFieldWrapper}
                        {standardRefundStyledFieldWrapper}
                      </>
                    ) : (
                      <>
                        {standardRefundStyledFieldWrapper}
                        {instantRefundStyledFieldWrapper}
                      </>
                    )}
                    <Button
                      className="mt-3"
                      type="submit"
                      fluid
                      primary
                      loading={loading || disableField}
                      disabled={
                        // !formikProps.isValid ||
                        disableField || splitErrorDisable
                      }
                      data-testid="submit-btn"
                      data-event-name="Primary_Button_Refund_Modal_Submit"
                      data-event-properties={JSON.stringify({
                        value: values.refundSpeed,
                      })}
                    >
                      {/* Update the button text between Standard and Instant */}
                      Initiate {titleCase(values.refundSpeed)} Refund of{' '}
                      {currency} {+roundOffNumber(values.refundAmount)}
                    </Button>
                  </form>
                );
              }}
            </FormikComponent>
          </div>
        </>
      );
    }
    return null;
  };

  return (
    <>
      <Conditional if={isLoading}>
        <Loader active={isLoading} />
      </Conditional>
      <Conditional
        if={!isLoading && open && modalContent?.name === INITIATE_REFUND}
      >
        <Modal open $maxWidth={536} ref={modalRef}>
          {!isSuccessful && (
            <>
              <ModalHeader>
                Initiate Refund{' '}
                <Cross
                  size="sm"
                  onClick={closeModalWithDataReset}
                  data-ignore-inner-text="true"
                  data-event-name="Form_InitiateRefundModalV2_Icon_Close"
                />
              </ModalHeader>
              <ModalContent className="pt-2 px-3 pb-3">
                <Loader active={loading} isModal paragraph={2} />
                {renderModalContent()}
              </ModalContent>
              <Conditional
                if={irEligibility?.defaultSpeed === upperCase(INSTANT)}
              >
                <StyledModalFooter variant="b12">
                  You can switch back to the standard refunds anytime from
                  settings.
                </StyledModalFooter>
              </Conditional>
              <Conditional
                if={!irEligibility?.eligibilityStatus && disabledIrError}
              >
                <StyledModalFooter variant="b12" className="light-bg">
                  {disabledIrError}
                </StyledModalFooter>
              </Conditional>
            </>
          )}
        </Modal>
      </Conditional>
      <Conditional if={modalContent?.name === INSUFFICIENT_BALANCE}>
        <InsufficientAmountModal
          data={modalContent?.data}
          walletBalance={walletStatus?.balance}
          closeModal={closeModalWithDataReset}
          onRefreshBalance={onRefreshBalance}
          onConfirmRecharge={onConfirmRecharge}
        />
      </Conditional>
      <Conditional if={modalContent?.name === RECHARGE_PENDING}>
        <RechargePendingModal />
      </Conditional>
      <Conditional if={modalContent?.name === 'REFUND_INITIATED'}>
        <RefundInitiatedModal
          // instantRefundsFreeTrialEligibility={instantRefundsFreeTrialEligibility}
          onActivateInstantly={onActivateInstantly}
          data={{ ...modalContent?.data, merchantAmount: merchantAmount || 0 }}
          closeModal={() => closeModalWithDataUpdate(false)}
          currency={currency}
        />
      </Conditional>
      <Conditional
        if={modalContent?.name === 'INSTANT_REFUND_ACTIVATION_SUCCESS'}
      >
        <InstantRefundsActivationSuccessfulModal />
      </Conditional>
    </>
  );
}

InitiateRefundModalV2.propTypes = {};

const mapStateToProps = createStructuredSelector({
  initiateRefundModalV2: makeSelectInitiateRefundModalV2(),
});

function mapDispatchToProps(dispatch) {
  return {
    createRefund: data => dispatch(createRefundAction(data)),
    enableLoader: () => dispatch(enableLoaderAction()),
    disableLoader: () => dispatch(disableLoaderAction()),
    getVendorData: data => dispatch(getVendorDataAction(data)),
    getMaximumRefund: data => dispatch(getMaximumRefundAction(data)),
    resetModalData: () => dispatch(resetModalDataAction()),
    getWalletStatus: data => dispatch(getWalletStatusAction(data)),
    getRechargeAccountDetails: data =>
      dispatch(getRechargeAccountDetailsAction(data)),
    getInstantRefundEligibility: data =>
      dispatch(getInstantRefundEligibilityAction(data)),
    updateDefaultRefundSpeed: data =>
      dispatch(updateDefaultRefundSpeedAction(data)),
    getObppStatus: data => dispatch(getObppStatusAction(data))
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withConnect,
  memo,
)(InitiateRefundModalV2);
